export default __webpack_public_path__ + "static/media/add-material.74a93779.svg";